import TryGoldButton from '@components/TryGoldButton';
import { GoldIcon } from '@icons';
import React from 'react';
import styles from './squareAd.module.scss';

const SquareAd: React.FC = () => (
  <div style={{ border: '2px solid transparent' }}>
    <div className={styles.container}>
      <div className={styles.content}>
        <h3 className={styles.title}>Discover the Pro</h3>

        <p className={styles.desc}>
          Hide ads, help pay for servers & development and unlock Pro only features like, sharing, advanced dashboard,
          extra storage space & more!
        </p>

        <TryGoldButton className={styles.button} />
      </div>

      <div className={styles.background} />
    </div>
  </div>
);

export default SquareAd;
